import { slice } from './slice';

const { reducer } = slice;
export * as loyaltyChartSelectors from './selectors';
export * from './types';

export default reducer;
